module.exports = __webpack_public_path__ + "img/donation-prep-4.40c7eb64.png";